import { GuidedTourController } from "./guidedTours/GuidedTourController";
import { Navbar } from "./components/Navbar/Navbar";
import PropTypes from "prop-types";

export const Layout = ({ children }) => {
  return (
    <div className="wrapper">
      <Navbar />
      <GuidedTourController />
      {children}
    </div>
  );
};

Layout.propTypes = {
  children: PropTypes.node,
};
